import * as THREE from '../libs/three';
(function () {
    'use strict';

    var dependencies = [];

    var service = function () {
        var getEntity = function (objOrEntity) {
            var result = null;
            if (objOrEntity instanceof THREE.Object3D) result = objOrEntity.userData.entity;
            else if (typeof objOrEntity === 'object') result = objOrEntity;
            return result;
        };

        return {
            isSuite: function (objOrEntity) {
                return objOrEntity && objOrEntity.isSuite;
            },
            isGrouppedSuite: function (obj) {
                return obj && obj.userData.suiteId && obj.userData.groupId;
            },
            isWall: function (objOrEntity) {
                var entity = getEntity(objOrEntity);
                return entity && entity.isWall;
            },
            isFloor: function (objOrEntity) {
                var entity = getEntity(objOrEntity);
                return entity && entity.isFloor;
            },
            isWallEmbeddable: function (objOrEntity) {
                var entity = getEntity(objOrEntity);
                return entity && entity.wallInteraction === 'embeddable';
            },
            isWallMountable: function (objOrEntity) {
                var entity = getEntity(objOrEntity);
                return entity && entity.wallInteraction === 'mountable';
            },
            isWindow: function (objOrEntity) {
                var entity = getEntity(objOrEntity);
                return entity && entity.category === 'windows';
            },
            sameWallInteraction: function (objOrEntity1, objOrEntity2) {
                var entity1 = getEntity(objOrEntity1);
                var entity2 = getEntity(objOrEntity2);
                return entity1 && entity2 && entity1.wallInteraction === entity2.wallInteraction;
            },
            isWallOrFloor: function (objOrEntity) {
                return this.isFloor(objOrEntity) || this.isWall(objOrEntity);
            }
        };
    };

    service.$inject = dependencies;

    angular.module('valleyCraftApp').service('objectCheckerSrvc', service);
})();
